module.exports = __webpack_public_path__ + "static/media/upload_image_placeholder.51aaa478.svg";